import { FC } from 'react';

import { TablePagination } from 'modules/_shared/Table/components/TablePagination';

import { usePartnerEncumbrances } from '../context/PartnerEncumbrancesContext';
import { EncumbrancesTableProvider } from '../../EncumbrancesTable/context/EncumbrancesTableContext';
import EncumbrancesTable from '../../EncumbrancesTable';

const PartnerEncumbrancesBody: FC = () => {
  const { data, actions } = usePartnerEncumbrances();

  const showPagination = data.encumbrances && data.totalEncumbrances > 10;

  return (
    <>
      <EncumbrancesTableProvider
        encumbrances={data.encumbrances}
        expandedRows={data.expandedRows}
        isAdmin={data.isAdmin}
        isReadOnly={data.isReadOnly}
      >
        <EncumbrancesTable />
      </EncumbrancesTableProvider>

      {showPagination && (
        <TablePagination
          totalRows={data.totalEncumbrances || 0}
          onChangePage={actions.handleChangePage}
          onChangeRowsPerPage={actions.handleChangeRowsPerPage}
        />
      )}
    </>
  );
};

export default PartnerEncumbrancesBody;
